import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { filterWatermarkedImages } from '../../util/data';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, ssrIsMobile, ...rest } = props;
  const optimizedImages = listing.attributes?.metadata?.optimizedImages;
  const { filteredImages, filteredOptimizedImages } = filterWatermarkedImages(
    listing.images,
    optimizedImages
  );
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  return (
    <section className={css.sectionRelative} data-testid="carousel">
      <ListingImageGallery
        images={filteredImages}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        listing={listing}
        optimizedImages={filteredOptimizedImages}
        ssrIsMobile={ssrIsMobile}
        {...rest}
      />
    </section>
  );
};

export default SectionGallery;
